import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { GrantedOperationService } from './granted-operation.service';

export function operationGuard(operation: string): CanActivateFn {
    return async (_route, state) => {
        const auth = inject(AuthService);
        const router = inject(Router);
        if (!auth.isAuthenticated()) {
            return router.createUrlTree(['/auth/login'], {
                queryParams: { returnUrl: state.url }
            });
        }
        const granted = inject(GrantedOperationService);
        await granted.ensureLoaded();
        return granted.has(operation) ? true : router.createUrlTree(['/faturamento/notas-fiscais']);
    };
}
